import VueI18Next from '@panter/vue-i18next';
import { inject, provide } from '@vue/composition-api';
import i18next from 'i18next';

const i18nSymbol = Symbol('Vue I18Next');

export function provideI18n() {
  const i18n = new VueI18Next(i18next);

  provide(i18nSymbol, i18n);
}

export const useI18N = () => {
  const i18n = inject<VueI18Next>(i18nSymbol);
  if (!i18n) throw new Error('I18n could not be provided!');

  return i18n;
};
